<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-tabs
          vertical
        >
          <v-tab>
            {{ $t('general') }}
          </v-tab>
          <v-tab
            align="right"
          >
            {{ $t('givenSetting') }}
          </v-tab>
          <v-tab
            align="right"
          >
            {{ $t('sell&buy') }}
          </v-tab>
          <v-tab
            align="right"
          >
            {{ $t('entrepot') }}
          </v-tab>
          <v-tab
            align="right"
          >
            {{ $t('kindProductGiven') }}
          </v-tab>
          <v-tab-item>
            <v-container>
              <v-subheader style="height: 25px">
                {{ $t('codeLength') }}
              </v-subheader>
              <v-divider
                class="mb-4"
              />
              <v-row class="mb-3">
                <v-col
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="accountingGroupLength"
                    :label="$t('group')"
                    outlined
                    :rules="[rules.required, rules.counter]"
                    dense
                    counter
                    maxlength="1"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="accountingTotalLength"
                    :label="$t('total')"
                    outlined
                    :rules="[rules.required, rules.counter]"
                    dense
                    counter
                    maxlength="1"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="accountingGivenLength"
                    :label="$t('given')"
                    outlined
                    clearable
                    :rules="[rules.required, rules.counter]"
                    dense
                    counter
                    maxlength="1"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="2"
                  class="pt-4"
                >
                  {{$t('sum')}} : {{+accountingGroupLength + +accountingTotalLength + +accountingGivenLength}}
                </v-col>
              </v-row>
              <v-subheader style="height: 25px">
                {{ $t('other') }}
              </v-subheader>
              <v-divider
                class="mb-0"
              />
              <v-row class="mb-3">
                <v-col>
                  <v-checkbox
                    v-model="accountingFillWithContent"
                    class="mt-0"
                    :label="$t('fillArticleWithContentIfEmpty')"
                    value="active"
                  />
                </v-col>
              </v-row>
              <v-card-actions>
                <v-row class="ma-0">
                  <v-col
                    cols="6"
                    class="px-1"
                  >
                    <v-btn
                      color="primary"
                      class="mr-0"
                      :loading="isLoading"
                      @click="create"
                    >
                      {{ $t('submit') }}
                    </v-btn>
                  </v-col>
                  <v-col
                    cols="6"
                    class="px-2"
                  >
                    <v-btn
                      color="grey"
                      outlined
                      class="float-left"
                      @click="$emit('close')"
                    >
                      {{ $t('cancel') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container>
              <generalGivenConfig />
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container>
              <given-config type-prop="invoice" />
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container>
              <given-config type-prop="entrepot" />
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container>
              <product-kind />
            </v-container>
          </v-tab-item>
        </v-tabs>
      </v-container>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  import productKind from './accountingKindProductGiven.vue'
  import givenConfig from './accountingGivenConfig.vue'
  import generalGivenConfig from './accountingGeneralGivenConfig.vue'
  import General from '../../../../../Mixins/general'
  // import autocomplete from '../../../components/general/patial/autocomplete'
  export default {
    name: 'Customer',
    components: {
      givenConfig,
      generalGivenConfig,
      productKind,
    },
    mixins: [General],
    data: () => ({
      accountingGroupLength: 2,
      accountingTotalLength: 2,
      accountingGivenLength: 2,
      rules: {
        required: value => !!value || 'Required.',
        counter: value => value.length <= 1 || 'Max 1 characters',
      },
      valid: true,
      select: 'accounting',
      accountingFillWithContent: null,
      render: false,
      isLoading: false,
    }),
    watch: {
    },
    activated () {
      this.show()
    },
    beforeMount () {
      this.rules = {
        required: value => !!value || this.$t('is-required'),
        counter: value => value.length <= 1 || 'Max 1 characters',
      }
    },
    mounted () {
      this.show()
    },
    methods: {
      addPaymentMethod () {
        this.paymentItems.push({
          bank: null,
          value: null,
        })
      },
      remove (index) {
        this.paymentItems.splice(index, 1)
      },
      create () {
        if (!this.$refs.form.validate()) return false
        var app = this
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'setting', this.$data)
          .then(res => {
            app.snakbarText = app.$t('registered')
            app.snakbarColor = 'green'
            app.snakbar = true
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      show () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'setting/' + 1 + '/edit', {
          params: {
            select: app.select,
          },
        })
          .then(res => {
            app.$nextTick(() => {
              res = res.data.data
              app.accountingGroupLength = res.accountingGroupLength
              app.accountingTotalLength = res.accountingTotalLength
              app.accountingGivenLength = res.accountingGivenLength
              app.accountingFillWithContent = res.accountingFillWithContent
              app.render = true
            })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      copied () {
        this.snakbarText = this.$t('copied')
        this.snakbarColor = 'blue'
        this.snakbar = true
      },
    },
  }
</script>

<style scoped>
.col{
  height: 55px !important;
}
</style>
